export default __webpack_public_path__ + "static/media/Charity_Branches.d22d8cf8.svg";